import React from 'react';
import { useForm } from 'react-hook-form';
import { injectIntl } from 'react-intl';
import searchBarApis from '../../utils/searchBarApis';
import {
  Button,
  ValidationError,
  CircularProgressLoader,
  AccessControl,
  PERMISSION_KEYS,
  PERMISSION_TYPES,
  FieldSearchBar,
} from '../../components';
import exp from '../../assets/svg/export.svg';
import '../../components/LayoutWrapperMain/LayoutWrapperMain.global.scss';

interface Props {
  handleFormSubmit: any,
  handleResetSorts: any,
  handleExport: any,
  intl: any,
  error: any,
  loaderExport: boolean,
}

enum ButtonTypes {
  'button',
  'submit',
  'reset',
  undefined
}

const SubAdminManagementFilter: React.FC<Props> = (props: Props) => {
  const {
    handleFormSubmit,
    intl,
    error,
    handleExport,
    loaderExport,
    handleResetSorts,
  } = props;
  const [toggle, setToggle] = React.useState(false);
  const formProps = useForm();
  const handleReset = () => {
    formProps.reset({
      search: '',
    });
    handleResetSorts();
  };
  return (
    <form
      className="filterForm"
      onSubmit={formProps.handleSubmit(handleFormSubmit)}
    >
      <div className="filter_container">
        <div className="filterSearch">
          <div>
            <div className="searchField">
              <FieldSearchBar
                searchURL={searchBarApis.subAdminManagement}
                formProps={formProps}
                name="search"
                label={intl.formatMessage({ id: 'SubAdminManagement.label.name' })}
                id="search"
              />
            </div>
          </div>
          <AccessControl
            permissionKey={PERMISSION_KEYS.SUB_ADMIN_MANAGEMENT}
            accessType={PERMISSION_TYPES.EDIT}
          >
            <div className="userRightExport">
              {!loaderExport
                ? (
                  <>
                    <span>
                      <img
                        src={exp}
                        alt="export"
                        role="presentation"
                        onClick={() => setToggle((prevState: boolean) => !prevState)}
                      />
                    </span>
                    {toggle && (
                      <ul className="userrigthToggle">
                        <li
                          role="presentation"
                          onClick={() => handleExport('XLSX')}
                        >
                          {intl.formatMessage({ id: 'SubAdminManagement.label.expot.xlsx' })}
                        </li>
                        <li
                          role="presentation"
                          onClick={() => handleExport('CSV')}
                        >
                          {intl.formatMessage({ id: 'SubAdminManagement.label.export.csv' })}
                        </li>
                      </ul>
                    )}
                  </>
                ) : <div className="exportProgressBar"><CircularProgressLoader /></div>}
            </div>
          </AccessControl>
        </div>
        <div className="filterOptions">
          <div className="buttonWrapper">
            <Button buttonType={ButtonTypes.submit} className="button">
              {intl.formatMessage({ id: 'SubAdminManagement.label.apply' })}
            </Button>
            <Button onClick={handleReset} className="button">
              {intl.formatMessage({ id: 'SubAdminManagement.label.reset' })}
            </Button>
          </div>
        </div>
        {error && (
          <ValidationError
            className="validation_error"
            error={error}
          />
        )}
      </div>
    </form>
  );
};

export default injectIntl(SubAdminManagementFilter);
